// AdminBookingsRoot — Events | Services sub-toggle for the admin Bookings tab.
import { useState } from 'react';
import AdminBookingsTab from './AdminBookingsTab';
import AdminServiceBookingsTab from './AdminServiceBookingsTab';

export default function AdminBookingsRoot() {
  const [sub, setSub] = useState('events');

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-gray-100 p-1 flex">
        <button
          data-testid="admin-bookings-sub-events"
          onClick={() => setSub('events')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-extrabold uppercase tracking-wider ${
            sub === 'events' ? 'bg-[#2B3A67] text-white' : 'text-gray-500'
          }`}
        >
          Event Tickets
        </button>
        <button
          data-testid="admin-bookings-sub-services"
          onClick={() => setSub('services')}
          className={`flex-1 py-2.5 rounded-xl text-xs font-extrabold uppercase tracking-wider ${
            sub === 'services' ? 'bg-[#2B3A67] text-white' : 'text-gray-500'
          }`}
        >
          Service Bookings
        </button>
      </div>

      {sub === 'events' ? <AdminBookingsTab /> : <AdminServiceBookingsTab />}
    </div>
  );
}
